import { Grid, Typography } from '@mui/material';
import React, { FC } from 'react';

import { muiStyles } from './styles';
import { DisplayCardProps } from './types';

export const DisplayCard: FC<DisplayCardProps> = (props) => {
    const {
        children,
        title,
        className
    } = props;

    const { Subtitle } = props.header || {};
    const { AboveHeaderComponent } = props.body || {};

    const classes = muiStyles(props);

    return (
        <Grid
            className={`${classes.root} ${className ? className : ''}`}
            container
            direction='column'
        >
            <Grid
                alignItems='center'
                className={classes.titleContainer}
                container
                justifyContent='space-between'
            >
                <Typography
                    className={classes.title}
                    data-testid='displayCard-title'
                    variant='body1'
                >
                    {title}
                </Typography>
                {typeof Subtitle === 'string' ? (
                    <Typography
                        className={classes.title}
                        data-testid='displayCard-subtitle'
                        variant='body1'
                    >
                        {Subtitle}
                    </Typography>
                ) : Subtitle ? (
                    <Subtitle />
                ) : null}
            </Grid>
            {AboveHeaderComponent ? <AboveHeaderComponent /> : null}
            <Grid
                className={classes.gridContainer}
                container
            >
                {children}
            </Grid>
        </Grid>
    );
};